import { useUser, useUserConfig } from '@/lib/hooks/context'

const useSiteUserAvatar = () => {
  const user = useUser()
  const config = useUserConfig()

  return config.avatar || user.image || ''
}
export default useSiteUserAvatar
